import * as React from "react";

interface SbpIconProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const SbpIcon: React.FC<SbpIconProps> = ({
  width = 97,
  height = 120,
  className,
  style
}) => {
  // Calculate the scaling factor to maintain aspect ratio
  const originalWidth = 97;
  const originalHeight = 120;

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      fill="none"
      className={className}
      style={style}
    >
      <path fill="#5B57A2" d="m0 26.12 14.532 25.975v15.844L.017 93.863z"></path>
      <path
        fill="#D90751"
        d="m55.797 42.643 13.617-8.346 27.868-.026-41.485 25.414z"
      ></path>
      <path fill="#FAB718" d="m55.72 25.967.077 34.39-14.566-8.95V0z"></path>
      <path
        fill="#ED6F26"
        d="m97.282 34.271-27.869.026-13.693-8.33L41.231 0z"
      ></path>
      <path
        fill="#63B22F"
        d="M55.797 94.007V77.322l-14.566-8.78.008 51.458z"
      ></path>
      <path
        fill="#1487C9"
        d="M69.38 85.737 14.531 52.095 0 26.12l97.223 59.583-27.844.034z"
      ></path>
      <path
        fill="#017F36"
        d="m41.24 120 14.556-25.993 13.583-8.27 27.843-.034z"
      ></path>
      <path
        fill="#984995"
        d="m.017 93.863 41.333-25.32-13.896-8.526-12.922 7.922z"
      ></path>
    </svg>
  );
};

export default SbpIcon;
